<script>
export default {
  name: 'NoBookingFound',
  emits: ['resetFilters'],
}
</script>

<template>
  <div class="empty-block">
    <div class="content">
      <h1>{{ $t('noSearchBookings.noBookingLable') }}</h1>
      <p>{{ $t('noSearchBookings.noBookingParagraph') }}</p>

      <div class="button">
        <BaseButton
          outlined
          light
          color="black"
          text-color="black"
          class="classButton me-5"
          @click="$emit('resetFilters')"
        >
          {{ $t('customeToolTip.clearFilters') }}
        </BaseButton>
        <BaseButton
          class="create-booking-btn"
          prepend-icon="mdi mdi-plus"
          width="170"
          @click="$router.push({ name: 'bookings-create' })"
        >
          {{ $t('bookingCreate.submitBtn') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/no-booking-found.scss';
</style>
